/**
 * Link
 */
// export const GOOGLE_CALENDAR_LINK = `https://calendar.google.com/calendar/event?action=TEMPLATE&dates=20201003T040000Z%2F20201003T060000Z&text=Dinda+%26+Indra+Wedding&details=Dinda+%26+Indra+Wedding`;
export const GOOGLE_MAPS_LINK = `https://maps.app.goo.gl/5pNCS4DB2AXaBJzA7`;

/**
 * Wedding time
 */
export const EPOCH_START_EVENT = 1720628594000;
export const EPOCH_END_EVENT = 1721492594000;
export const UTC_WEDDING_TIME = '2024-07-10:04:00:00Z';
